import React from 'react';

import { logout } from 'src/auth';
import AuthErrorPage from 'src/components/Auth/AuthErrorPage';
import Loading from 'src/components/Loading';
import FlashesStore from 'src/stores/FlashesStore';
import { AUTH_ERROR_DEFAULT } from 'src/util/constants';
import { localizeSameOriginUrl } from 'src/util/i18n/localeUrl';
import buildLoginRedirectUrl from 'src/util/links/login';

/**
 * Handles deactivated user error by logging out the user and
 * redirecting to deactivated page
 */
export const handleDeactivatedUserError = () => {
  logout({
    onCompleted: () => {
      console.log('User logged out');
      window.location.replace(localizeSameOriginUrl('/auth/deactivated'));
    },
    onError: (err) => {
      console.error('Logout error:', err);
      window.location.replace(localizeSameOriginUrl('/auth/deactivated'));
    },
  });
};

/**
 * Handles the application error while login.
 * @param {object} props - props object
 * @param {object} error - error object
 * @returns {React.ReactElement|null} Loading component or null
 */
export const handleApplicationErrors = (props, error) => {
  if (!props && !error) {
    return <Loading />;
  }

  if (error || (props && !props.viewer)) {
    // Clear any existing flash messages
    FlashesStore.reset();

    // Consolidate all error messages from GraphQL errors array
    const errorList = error?.source?.errors;
    if (errorList && Array.isArray(errorList)) {
      const errorMessages = errorList
        .map((err) => err.message)
        .filter((message) => message)
        .join(', ');

      if (errorMessages) {
        // Check whether user is deactivated
        if (errorMessages.includes('lister: user: uuid is nil')) {
          handleDeactivatedUserError();
          return <Loading />;
        }
      }
    }

    // HTTP 401/403 never reach here: the Relay network layer
    // (src/util/environment.js) redirects to login or /403 and keeps the
    // request pending.

    // A successful response with no viewer is the unauthenticated case, with no
    // stale tokens to clear, so redirect straight to login. Any other error
    // (500, unreachable API, etc.) renders the error page without changing the
    // URL, so a server or network failure cannot loop back through login.
    if (!error && props && !props.viewer) {
      window.location.replace(buildLoginRedirectUrl());
      return <Loading />;
    }

    return <AuthErrorPage errorType={AUTH_ERROR_DEFAULT} />;
  }

  return null;
};
